import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { visualizerActions } from "../../store";
import Product from '../Product/Product';
import styles from './ProductList.module.css';

export default function ProductList({ seriesId, thumbSize = "256", headerColumn = "manufacturerSeriesName", className = "", categoryFilter = "" }) {
    const dispatch = useDispatch();
    const [productData, setProductData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const selectedSlot = useSelector(state => state.visualizer.selectedSlot);

    // Product selection handler
    const handleProductSelect = (id) => {
        const selectedProduct = productData.find(product => product.id === id);
        if (selectedProduct) {
            // Store the product in the currently selected slot
            dispatch(visualizerActions.setSlotProduct({
                slotIndex: selectedSlot,
                product: {
                    ...selectedProduct,
                    series: seriesId
                }
            }));
            console.log('Product selected for slot', selectedSlot, ':', selectedProduct);
        }
    };

    // Fetch product data
    useEffect(() => {
        const URL = `https://lizard.chameleonpower.com/CDN/ProductsBySeries/${seriesId}.json`;
        fetch(URL)
            .then((response) => response.json())
            .then((data) => {
                setProductData(data);
            })
            .catch((error) => {
                console.error('Error fetching products:', error);
            });
    }, [seriesId]);
    


    // Filter products based on search term and category
    const filteredProducts = productData.filter(product => {
        // First apply category filter if specified
        if (categoryFilter) {
            const description = (product.description || '').toLowerCase();
            const categoryLower = categoryFilter.toLowerCase();
            
            // Special case for "solid" - show products with empty description
            if (categoryLower === 'solid') {
                if (description !== 'solid') {
                    return false;
                }
            } else {
                // Check if the product description contains the category
                if (!description.includes(categoryLower)) {
                    return false;
                }
            }
        }
        
        // Then apply search term filter
        if (!searchTerm) return true;
        
        const searchLower = searchTerm.toLowerCase();
        const name = (product.name || '').toLowerCase();
        const color = (product.color || '').toLowerCase();
        const manufacturerSeriesName = (product.manufacturerSeriesName || '').toLowerCase();
        
        return name.includes(searchLower) || 
               color.includes(searchLower) || 
               manufacturerSeriesName.includes(searchLower);
    });

    // Handle search input
    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    // Render filtered products in a simple grid
    const productItems = filteredProducts.map(product => (
        <Product
            key={product.id}
            id={product.id}
            specifier={product.specifier}
            focus={500}
            size={thumbSize}
            title={product.color}
            description={product.name}
            series={seriesId}
            onSelect={handleProductSelect}
            favorites={{}}
            onFavorite={() => {}}
            isActive={false}
            addToBoard={() => {}}
        />
    ));

    return (
        <div className={styles.thumbMenu}>
            <div className={styles.searchContainer}>
                <input
                    type="text"
                    placeholder="Search by collection, style or color"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    className={styles.searchInput}
                />
                <button className={styles.searchButton}>
                   ⌕
                </button>
            </div>
            
            <div className={`${styles.productList}`} data-series={seriesId}>
                {productItems.length > 0 ? (
                    productItems
                ) : (
                    <div className={styles.emptyMessage}>
                        {searchTerm ? 'No products match your search.' : 'No products available.'}
                    </div>
                )}
            </div>
        </div>
    );
      
}